module.exports = __webpack_public_path__ + "static/img/第二十二届.8e687e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/20260620/past/第二十二届.png
// module id = Oi0D
// module chunks = 1